// AuthCallback — handles the redirect from Emergent Google OAuth.
// URL will look like: /auth/callback#session_id=xxxxx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { API } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) {
      toast.error('No Google session returned. Please retry.');
      navigate('/login', { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google/callback`, { session_id: sessionId });
        toast.success(data.new_user ? `Welcome, ${data.name}! Ask Super Admin to set your role.` : `Welcome back, ${data.name}!`);
        await checkAuth();
        navigate('/', { replace: true });
      } catch (err) {
        toast.error(err.response?.data?.detail || 'Google sign-in failed');
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <Loader2 className="w-8 h-8 animate-spin" style={{ color: 'var(--navy)', margin: '0 auto' }} />
        <p style={{ marginTop: 12, color: '#555' }}>Signing you in with Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
